import { Box } from '@mui/material';
import { Skeleton } from '@mui/lab';
import React, { CSSProperties } from 'react';

interface GalleryImageSkeletonProps {
  style?: CSSProperties;
}

const GalleryImageSkeleton = ({ style }: GalleryImageSkeletonProps) => {
  return (
    <div style={style}>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          aspectRatio: '1 / 1',
          backgroundColor: 'white',
          border: '1px solid #eee',
          padding: '4px',
          boxSizing: 'border-box',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Skeleton
          variant='rectangular'
          width='100%'
          height='100%'
          animation='wave'
          sx={{ borderRadius: 1 }}
        />
      </Box>
    </div>
  );
};

export default GalleryImageSkeleton;
